<template>
    <div class="" style="background-color: #fef3f3">
        <div class="inner paddingH12 paddingT8" style="line-height: 20px;">
            <van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false"
                   :vertical="true" style="height: 30px;">
                <van-swipe-item v-for="dataItem in dataList" :key="dataItem.id">
                    <div class="flexLayout" style="margin-bottom: 10px; height: 20px;" :data-biztype="dataItem.bizType">
                        <div style="width: 50px;">
                            <span class="textLabel" :class="{redTextLabel: dataItem.bizType == bizTypeEnum.DATUM.code,
                                blueTextLabel: dataItem.bizType == bizTypeEnum.ATLAS.code,
                                yellowTextLabel: dataItem.bizType == bizTypeEnum.THIRD_PARTY.code}">上新</span>
                        </div>
                        <div class="flexItem hiddenOverflow showEllipsisIfOverflow" style="height: 20px;"
                            @click="viewItem(dataItem)">
                            {{ dataItem.title }}
                        </div>
                        <div class="alignR" style="width: 70px;">
                            <router-link to="/discoverLatest" class="button viewAllButton">查看全部</router-link>
                        </div>
                    </div>
                </van-swipe-item>
<!--                <van-swipe-item>1</van-swipe-item>-->
<!--                <van-swipe-item>2</van-swipe-item>-->
<!--                <van-swipe-item>3</van-swipe-item>-->
<!--                <van-swipe-item>4</van-swipe-item>-->
            </van-swipe>
        </div>

    </div>
</template>

<script>
import generalCmpPart from '@/components/part/generalCmpPart';

import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);

// data
import bizTypeEnum from "@data/bizTypeEnum";

// util
import {toDetailByBizType} from '@/components/shixunApp/toDetail';

const config = {
    apiConfig : {
        list : {
            url : 'portal/v4/index/newBizInfo',
            dataPath : 'data'
        }
    }
};

export default {
    name: "latestContent",
    extends : generalCmpPart,
    data () {
        return {
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : true,
            bizTypeEnum
        }
    },
    methods : {

        viewItem(dataItem) {
            toDetailByBizType(dataItem.bizType, dataItem.id);
        }
    }
}
</script>

<style lang="scss" scoped>
.textLabel {
    color: white;
    font-size: 12px;
    line-height: 16px;
}
.redTextLabel {
    background-color: #F46C64;
}
.blueTextLabel {
    background-color: #61B5FD;
}
.yellowTextLabel {
    background-color: #FFD411;
}

.viewAllButton {
    width: 60px;
    height: auto;
    border: solid 1px #ffbaba;
    color: #ffbaba;
    font-size: 12px;
    line-height: 16px;
    padding: 0;
}
</style>
